<custom-modal
  [header]="'LHCB_MIGRATION_POPUP.HEADER'"
  [open]="isOpen"
  [isOpenOrCloseOnInit]="true"
  [modalClass]="'lhcb-migration-modal'"
  [size]="'md'"
  [isShowTopDecorationLine]="true"
  [isListenClose]="true"
  (closeClick)="onDiscard()"
>
  <div class="lhcb-migration-modal__body">
    <p class="lhcb-migration-modal__intro">
      {{ "LHCB_MIGRATION_POPUP.BODY_INTRO" | translate }}
    </p>
    <p class="lhcb-migration-modal__subheader">
      {{ "LHCB_MIGRATION_POPUP.SUBHEADER_NOTHING_CHANGES" | translate }}
    </p>
    <ul class="lhcb-migration-modal__list">
      <li>{{ "LHCB_MIGRATION_POPUP.BULLET_HISTORY" | translate }}</li>
      <li>{{ "LHCB_MIGRATION_POPUP.BULLET_WORKFLOW" | translate }}</li>
    </ul>
    <p class="lhcb-migration-modal__poa-note">
      {{ "LHCB_MIGRATION_POPUP.BODY_POA" | translate }}
    </p>
    <app-lhcb-coupon-banner [couponCode]="couponCode" [poaPrice]="poaPrice"></app-lhcb-coupon-banner>
  </div>

  <button
    footer-action
    type="button"
    class="btn btn-secondary lhcb-migration-modal__discard-btn"
    [disabled]="isAcknowledging"
    (click)="onDiscard()"
  >
    <span *ngIf="isAcknowledging && activeAction === 'discard'" class="fa fa-spinner fa-spin mr-1"></span>
    {{ "LHCB_MIGRATION_POPUP.BUTTON_DISCARD" | translate }}
  </button>
  <button
    footer-action
    type="button"
    class="btn btn-primary ml-2 lhcb-migration-modal__sign-btn"
    [disabled]="isAcknowledging"
    (click)="onSignThePoa()"
  >
    <span *ngIf="isAcknowledging && activeAction === 'sign'" class="fa fa-spinner fa-spin mr-1"></span>
    {{ "LHCB_MIGRATION_POPUP.BUTTON_SIGN_POA" | translate }}
  </button>
</custom-modal>
